import { fetcher } from "@/shared/core-configs";
import qr from "query-string";
import { API } from "@/config";
import { Product } from "@/shared/core-products";

export const getProductByCode = async (
  code: string,
  storageId?: string,
): Promise<Product> => {
  const params = qr.stringify({ code, storageId });

  const response = await fetcher.get(
    `${API.GESLUB}/product/get-by-code?${params}`,
  );
  return response.data;
};
